//#region src/order_throttling_method.ts
var OrderThrottlingMethod = /* @__PURE__ */ function(OrderThrottlingMethod) {
	OrderThrottlingMethod["DollarValue"] = "dollar-value";
	OrderThrottlingMethod["OrderCount"] = "order-count";
	return OrderThrottlingMethod;
}(OrderThrottlingMethod || {});
//#endregion
export { OrderThrottlingMethod };

//# sourceMappingURL=order_throttling_method.js.map